module.exports = __webpack_public_path__ + "img/copper-coin-fill.f2ad2281.svg";